(() => {
  const PAGE_PATH = '/pages/for-biz';
  const HUBSPOT_FORM_RE = /share\.hsforms\.com\/1P7TnrxK6S4GMLqbBvCr3QQnwbzi/;
  const SCROLL_DEPTHS = [25, 50, 75, 90, 100];
  const viewedSections = new Set();
  const reachedScrollDepths = new Set();

  const ctaTargets = [
    {
      id: 'for_biz_header_contact',
      position: 'header',
      sectionId: 'header',
      selector: '.l-header a[data-prairie-hubspot-attribution-link], .header a[data-prairie-hubspot-attribution-link]'
    },
    {
      id: 'for_biz_hero_primary',
      position: 'hero_primary',
      sectionId: 'hero',
      selector: '.biz-v2__hero-primary-cta'
    },
    {
      id: 'for_biz_hero_case_study',
      position: 'hero_secondary',
      sectionId: 'hero',
      selector: '.biz-v2__hero-secondary-actions-link[href="#case-study"]'
    },
    {
      id: 'for_biz_hero_next_pricing',
      position: 'hero_next_action',
      sectionId: 'hero',
      selector: '.biz-v2__hero-secondary-actions-link[href="#prairie-for-business-price"]'
    },
    {
      id: 'for_biz_hero_bottom_contact',
      position: 'hero_bottom',
      sectionId: 'hero',
      selector: '.biz-v2__btn-bottom-cta'
    },
    {
      id: 'for_biz_case_next_pricing',
      position: 'case_study_next_action',
      sectionId: 'case_study',
      selector: '.biz-v2__case-study-next-action-link[href="#prairie-for-business-price"]'
    },
    {
      id: 'for_biz_case_next_contact',
      position: 'case_study_next_action',
      sectionId: 'case_study',
      selector: '.biz-v2__case-study-next-action-link[href="#contact"]'
    },
    {
      id: 'for_biz_contact',
      position: 'contact',
      sectionId: 'contact',
      selector: '.biz-v2__contact-btn'
    },
    {
      id: 'for_biz_lead_form_request',
      position: 'lead_form',
      sectionId: 'lead_form',
      selector: '.biz-v2-lead-form__cta'
    }
  ];

  const sectionTargets = [
    { id: 'hero', name: 'Hero', selector: '.biz-v2__hero-section' },
    { id: 'benefits', name: 'Benefits', selector: '.biz-v2__customers-and-benefit-section' },
    { id: 'about', name: 'About Prairie Card', selector: '.biz-v2__prairie-card-section' },
    { id: 'features', name: 'Features', selector: '.biz-v2__functions' },
    { id: 'profile', name: 'Profile Page', selector: '.biz-v2__profile-section' },
    { id: 'profile_slider', name: 'Profile Slider', selector: '#profile-slider' },
    { id: 'service_comparison', name: 'Service Comparison', selector: '.biz-v2__service-comparison-section' },
    { id: 'business_plan', name: 'Business Plan', selector: '.biz-v2__business-plan-section' },
    { id: 'patent', name: 'Patent', selector: '.biz-v2__patent-section' },
    { id: 'case_study', name: 'Case Studies', selector: '#case-study' },
    { id: 'pricing', name: 'Pricing', selector: '#pricing, #prairie-for-business-price' },
    { id: 'faq', name: 'FAQ', selector: '#faq' },
    { id: 'contact', name: 'Contact', selector: '#contact' },
    // 既存セクションのview_orderを変えないため末尾に追加（ページ上の位置はProfile Sliderの直後）
    { id: 'lead_form', name: 'Lead Form', selector: '#lead-form' }
  ];

  const isForBizPage = () => {
    const pathname = window.location.pathname.replace(/\/$/, '');
    return pathname === PAGE_PATH;
  };

  const isLocalhost = () => {
    return window.location.hostname === 'localhost'
      || window.location.hostname === '127.0.0.1'
      || window.location.hostname === '::1';
  };

  const getText = (element) => {
    const explicitLabel = element.dataset.prairieBizLpCtaText;
    if (explicitLabel) return explicitLabel.replace(/\s+/g, ' ').trim().slice(0, 120);

    return (element.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120);
  };

  const getDestinationType = (href) => {
    if (!href) return 'unknown';
    if (HUBSPOT_FORM_RE.test(href)) return 'hubspot_form';
    if (href.startsWith('#') || href.includes('/pages/for-biz#')) return 'anchor';
    if (href.startsWith('/') || href.includes(window.location.hostname)) return 'internal';
    return 'external';
  };

  const getBaseParams = () => {
    return {
      page_path: window.location.pathname,
      page_location: window.location.href,
      page_title: document.title,
      viewport_width: window.innerWidth,
      value: 1
    };
  };

  const pushEvent = (eventName, params) => {
    const payload = {
      event: eventName,
      event_category: 'for_biz_lp',
      ...getBaseParams(),
      ...params
    };

    window.prairieForBizLpEvents = window.prairieForBizLpEvents || [];
    window.prairieForBizLpEvents.push({
      ...payload,
      debug_local_only: isLocalhost()
    });

    if (isLocalhost()) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  const initCtaTracking = () => {
    ctaTargets.forEach((target) => {
      document.querySelectorAll(target.selector).forEach((link) => {
        if (link.dataset.prairieBizLpTracked === 'true') return;

        link.dataset.prairieBizLpTracked = 'true';
        link.addEventListener('click', () => {
          const destination = link.getAttribute('href') || link.href || '';

          pushEvent('biz_lp_cta_click', {
            cta_id: target.id,
            cta_position: target.position,
            cta_text: getText(link),
            section_id: target.sectionId,
            destination,
            destination_type: getDestinationType(destination)
          });
        });
      });
    });
  };

  const initSectionTracking = () => {
    if (!('IntersectionObserver' in window)) return;

    const sectionByElement = new Map();

    sectionTargets.forEach((target, index) => {
      document.querySelectorAll(target.selector).forEach((element) => {
        sectionByElement.set(element, { ...target, viewOrder: index + 1 });
      });
    });

    if (!sectionByElement.size) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const section = sectionByElement.get(entry.target);
        if (!section) return;

        observer.unobserve(entry.target);

        if (viewedSections.has(section.id)) return;

        viewedSections.add(section.id);
        pushEvent('biz_lp_section_view', {
          section_id: section.id,
          section_name: section.name,
          view_order: section.viewOrder
        });
      });
    }, {
      rootMargin: '-40% 0px -40% 0px',
      threshold: 0
    });

    sectionByElement.forEach((section, element) => {
      observer.observe(element);
    });
  };

  const getScrollPercent = () => {
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollableHeight <= 0) return 100;

    return Math.min(100, Math.max(0, Math.floor((window.scrollY / scrollableHeight) * 100)));
  };

  const syncScrollDepth = () => {
    const percent = getScrollPercent();

    SCROLL_DEPTHS.forEach((depth) => {
      if (percent < depth || reachedScrollDepths.has(depth)) return;

      reachedScrollDepths.add(depth);
      pushEvent('biz_lp_scroll_depth', {
        depth,
        max_depth: percent
      });
    });
  };

  const initScrollTracking = () => {
    let ticking = false;

    const schedule = () => {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(() => {
        syncScrollDepth();
        ticking = false;
      });
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    syncScrollDepth();
  };

  // 事例一覧の「もっと見る」（スマホ）。折りたたみ（2026-10-05公開）の効果を読むため、展開されたカテゴリを記録する
  const initCaseExpandTracking = () => {
    document.querySelectorAll('#case-study .show-all[aria-controls]').forEach((button) => {
      if (button.dataset.prairieBizLpTracked === 'true') return;

      button.dataset.prairieBizLpTracked = 'true';
      button.addEventListener('click', () => {
        const listId = button.getAttribute('aria-controls');
        const heading = button.closest('.v2-all-blog__section')?.previousElementSibling;
        const categoryLabel = heading && /^H[1-6]$/.test(heading.tagName) ? getText(heading) : '';

        pushEvent('biz_lp_cta_click', {
          cta_id: 'for_biz_case_expand',
          cta_position: 'case_study_expand',
          cta_text: categoryLabel || getText(button),
          section_id: 'case_study',
          destination: `#${listId}`,
          destination_type: 'anchor'
        });
      });
    });
  };

  const init = () => {
    if (!isForBizPage()) return;

    initCtaTracking();
    initCaseExpandTracking();
    initSectionTracking();
    initScrollTracking();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
